import React, { lazy } from 'react'

const toDefault = (result: {
  ReactComponent: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined
    }
  >
}) => ({ default: result.ReactComponent })

export const AVATAR_ICONS_LIST = {
  'academic-cap': lazy(() => import('./assets/academic-cap.svg').then(toDefault)),
  bulldozer: lazy(() => import('./assets/bulldozer.svg').then(toDefault)),
  'camera-2': lazy(() => import('./assets/camera-2.svg').then(toDefault)),
  camera: lazy(() => import('./assets/camera.svg').then(toDefault)),
  car: lazy(() => import('./assets/car.svg').then(toDefault)),
  checklist: lazy(() => import('./assets/checklist.svg').then(toDefault)),
  crane: lazy(() => import('./assets/crane.svg').then(toDefault)),
  drone: lazy(() => import('./assets/drone.svg').then(toDefault)),
  'electrical-grid': lazy(() => import('./assets/electrical-grid.svg').then(toDefault)),
  farm: lazy(() => import('./assets/farm.svg').then(toDefault)),
  grass: lazy(() => import('./assets/grass.svg').then(toDefault)),
  harvester: lazy(() => import('./assets/harvester.svg').then(toDefault)),
  hose: lazy(() => import('./assets/hose.svg').then(toDefault)),
  irrigation: lazy(() => import('./assets/irrigation.svg').then(toDefault)),
  obstacle: lazy(() => import('./assets/obstacle.svg').then(toDefault)),
  'map-route': lazy(() => import('./assets/map-route.svg').then(toDefault)),
  robot: lazy(() => import('./assets/robot.svg').then(toDefault)),
  roof: lazy(() => import('./assets/roof.svg').then(toDefault)),
  room: lazy(() => import('./assets/room.svg').then(toDefault)),
  sprayer: lazy(() => import('./assets/sprayer.svg').then(toDefault)),
  sprinkler: lazy(() => import('./assets/sprinkler.svg').then(toDefault)),
  sprout: lazy(() => import('./assets/sprout.svg').then(toDefault)),
  stacker: lazy(() => import('./assets/stacker.svg').then(toDefault)),
  'surveillance-camera': lazy(() => import('./assets/surveillance-camera.svg').then(toDefault)),
  'tractor-2': lazy(() => import('./assets/tractor-2.svg').then(toDefault)),
  'tractor-farm': lazy(() => import('./assets/tractor-farm.svg').then(toDefault)),
  tractor: lazy(() => import('./assets/tractor.svg').then(toDefault)),
  wall: lazy(() => import('./assets/wall.svg').then(toDefault)),
  'wind-turbine': lazy(() => import('./assets/wind-turbine.svg').then(toDefault)),
  'dump-truck': lazy(() => import('./assets/dump-truck.svg').then(toDefault)),
  excavator: lazy(() => import('./assets/excavator.svg').then(toDefault)),
  loader: lazy(() => import('./assets/loader.svg').then(toDefault)),
  'implement-cart': lazy(() => import('./assets/Implement-cart.svg').then(toDefault)),
  combine: lazy(() => import('./assets/combine.svg').then(toDefault)),
  'commercial-mower': lazy(() => import('./assets/commercial-mower.svg').then(toDefault)),
  crawler: lazy(() => import('./assets/crawler.svg').then(toDefault)),
  fo: lazy(() => import('./assets/fo.svg').then(toDefault)),
  gator: lazy(() => import('./assets/gator.svg').then(toDefault)),
  'generic-construction': lazy(() => import('./assets/generic-construction.svg').then(toDefault)),
  'skid-mower': lazy(() => import('./assets/skid-mower.svg').then(toDefault)),
  'tillage-implement': lazy(() => import('./assets/tillage-implement.svg').then(toDefault)),
  truck: lazy(() => import('./assets/truck.svg').then(toDefault)),
  'turf-gator': lazy(() => import('./assets/turf-gator.svg').then(toDefault)),
  turf: lazy(() => import('./assets/turf.svg').then(toDefault)),
} as const

export type AvailableAvatarIcons = keyof typeof AVATAR_ICONS_LIST

export const AvailableAllAvatarIcons = Object.keys(AVATAR_ICONS_LIST) as AvailableAvatarIcons[]
